var ctrl = function (
  $scope,
  $state,
  $stateParams,
  $http,
  Flash,
  C,
  referralLeadsRes,
  referralCodeRes,
  userRes,
  $rootScope,
) {
  $scope.referralCode = referralCodeRes.data.code;
  $scope.referralLeads = referralLeadsRes.data || [];
  $scope.submittingData = false;
  $scope.newReferralReward = C.APP_NAME == "retailer";
  $scope.user = userRes.data || {};

  $scope.hideReferralIncentive =
    C.APP_NAME === "distributor" &&
    !!$scope.user.distributors.find(function (distributor) {
      return (
        distributor.hide_referral_incentive === true &&
        distributor.distributor_id == $rootScope.currentDistributor
      );
    });

  var refreshState = function (changes) {
    var newParams = angular.copy($stateParams);
    _.extend(newParams, changes);
    $state.go(".", newParams);
  };

  $scope.pagination = {
    perPage: parseInt(referralLeadsRes.headers("X-Pagination-Limit")),
    page: Number($stateParams.page || 1),
    totalEntries: parseInt(referralLeadsRes.headers("X-Pagination-Entries")),
    goToPage: function (n) {
      refreshState({ page: n });
    },
  };

  $scope.totalEarnings = 0;

  var getTotalEarnings = function () {
    $http({
      method: "GET",
      url: "/api/" + C.APP_NAME + "/referral_code/earnings",
    }).then(function success(res) {
      $scope.totalEarnings = Number(res.data.total) || 0;
    });
  };
  getTotalEarnings();

  /*
   * Update User
   */

  var updateDistributorUser = function () {
    if (C.APP_NAME != "distributor") {
      return;
    }
    $scope.$emit("distributorUpdateReferralCodeHeader", $scope.referralCode);
  };
  updateDistributorUser();

  /*
   * Sending New Invites
   */

  $scope.sendInvite = function () {
    if ($scope.submittingData) {
      return;
    }
    $scope.submittingData = true;

    $http({
      method: "POST",
      url: "/api/" + C.APP_NAME + "/referral_leads",
      data: {
        name: $scope.newReferralLead.name,
        sent_to_email: $scope.newReferralLead.sent_to_email,
        sent_to_phone: $scope.newReferralLead.sent_to_phone,
      },
    })
      .then(
        function success(res) {
          $scope.referralLeads.unshift(res.data);
          $scope.newReferralLead = {};
          Flash.setMessage("Invite Sent", true, "notice");
        },
        function errors(res) {
          if (res && res.data && res.data.errors) {
            $scope.errors = res.data.errors;
          }
        },
      )
      .finally(function () {
        $scope.submittingData = false;
      });
  };

  /*
   * Resending Invites
   */

  $scope.resendInvite = function (referralLeadId) {
    if ($scope.submittingData) {
      return;
    }
    $scope.submittingData = true;

    $http({
      method: "PUT",
      url: "/api/" + C.APP_NAME + "/referral_leads/" + referralLeadId + "/resend",
    })
      .then(function success(res) {
        var referralLead = _.find($scope.referralLeads, ["id", referralLeadId]);
        _.extend(referralLead, res.data);
        Flash.setMessage("Invite Resent", true, "notice");
      })
      .finally(function () {
        $scope.submittingData = false;
      });
  };

  $scope.shouldShowInvite = function (referralLead) {
    if (!referralLead.sent_at) {
      return false;
    }

    if (referralLead.state == "opened") {
      return true;
    }
    if (referralLead.state == "sent") {
      // Do not show until after 24 hours have passed
      // since last sending the invite
      var isAfter24Hours = moment().diff(referralLead.sent_at, "m") > 1440;
      var resentLimit = C.APP == "retailer" ? 2 : 25;
      return isAfter24Hours && referralLead.resends < resentLimit;
    }

    return false;
  };
};

ctrl.$inject = [
  "$scope",
  "$state",
  "$stateParams",
  "$http",
  "Flash",
  "C",
  "referralLeadsRes",
  "referralCodeRes",
  "userRes",
  "$rootScope",
];

tiz.controller("ReferralsCtrl", ctrl);
